import { cn } from "@faire/react/tools/cn";
import { exhaustiveSwitch } from "@faire/typescript";

export enum TrackingTargetType {
  COMPONENT = "COMPONENT",
  COMPONENT_GROUP = "COMPONENT_GROUP",
  ICON = "ICON",
}

export const getTrackingCls = (targetType: TrackingTargetType) => {
  switch (targetType) {
    case TrackingTargetType.COMPONENT:
      return "fs-component";
    case TrackingTargetType.COMPONENT_GROUP:
      return "fs-component-group";
    case TrackingTargetType.ICON:
      return "fs-icon";
    default:
      return exhaustiveSwitch(targetType, { defaultValue: "" });
  }
};

export const componentCls = (...cls: Array<string | undefined>) =>
  cn(...cls, getTrackingCls(TrackingTargetType.COMPONENT));

export const componentGroupCls = (...cls: Array<string | undefined>) =>
  cn(...cls, getTrackingCls(TrackingTargetType.COMPONENT_GROUP));

export const iconCls = (...cls: Array<string | undefined>) =>
  cn(...cls, getTrackingCls(TrackingTargetType.ICON));
